const toInt = (s, defaultValue = null) => {
  const value = parseInt(s, 10)

  return isNaN(value) ? defaultValue : value
}

export default toInt
